export class PayoutSource {
    id: number;
    payoutConfigId: number;

    rodeoEventId: number;
    scheduleId: number;
    sidepotId: number;

    round: number;
    rotation: number;
    fromTotalTimeScore: boolean;
    amountToPot: number;
    isAverage: boolean;
    isAggregate: boolean;
    onXRounds: number;
    addToCount: boolean;
    byRunIdentifier: boolean;

    constructor() {
        this.addToCount = true;
        this.onXRounds = 0;
        this.byRunIdentifier = true;
    }
}


// WEBPACK FOOTER //
// ./src/model/payout-source.ts